import { useEffect, useState } from "react";
import { ButtonLink } from "../../../../../shared/components/link/ButtonLink";
import classNames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { FormView } from "../index";
import { button, buttonLarge, buttonShort } from "./style.css";

type SaveButtonProps = {
  formView: FormView;
  onSubmit: (event: React.MouseEvent) => void;
  isLoading?: boolean;
  saveText?: string;
  sendText?: string;
};

export const SaveButton = ({
  formView,
  onSubmit,
  isLoading,
  saveText,
  sendText,
}: SaveButtonProps) => {
  // animation should't work when mounted
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true);
    }
  }, []);

  return (
    <ButtonLink
      className={classNames(button, {
        [buttonShort]: formView === FormView.FORM,
        [buttonLarge]: formView === FormView.MESSAGE,
      })}
      onClick={onSubmit}
      isLoading={isLoading}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={formView}
          initial={
            hasMounted
              ? {
                  y: formView === FormView.FORM ? "-110%" : "110%",
                }
              : undefined
          }
          animate={{ y: "0%" }}
          exit={{
            y: formView === FormView.FORM ? "-110%" : "110%",
          }}
          transition={{ duration: 0.18, ease: "easeInOut" }}
        >
          {formView === FormView.FORM ? (
            <div>{sendText ?? "Send"}</div>
          ) : (
            <div>{saveText ?? "Save message"}</div>
          )}
        </motion.div>
      </AnimatePresence>
    </ButtonLink>
  );
};
